import { firstValueFrom } from 'rxjs';
import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpService } from './http.service';
import { EndPoint } from '../config/endpoint';

@Injectable({
  providedIn: 'root',
})
export class ChartService {
  private year = ['2012', '2013', '2014', '2015', '2016', '2017', '2018'];
  totalAssignments: number[] = [];
  totalStudentsTakenAssignments: number[] = [];
  studentsCompletedAssignments: number[] = [];
  dates = [];
  private data = {};

  constructor(private httpService: HttpService) {
    // this.data = {
    //   week: this.getDataForWeekPeriod(),
    //   month: this.getDataForMonthPeriod(),
    //   year: this.getDataForYearPeriod(),
    // };
  }

  public async initializeData(): Promise<void> {
    try {
      this.data = {
        week: await this.getDataForWeekPeriod(),
        month: this.getDataForMonthPeriod(),
        year: this.getDataForYearPeriod(),
      };
    } catch (error) {
      console.error('Error initializing chart data:', error);
    }
  }

  async getAssignmentEvaluationAndUsers(queryParams: object) {
    try {
      const response = await firstValueFrom(
        this.httpService.get<any>(
          `${environment.XANO_SERVER_URL}${EndPoint.students_and_assignments_academic_progress}`,
          {
            params: queryParams,
          },
        ),
      );
      return this.httpService.decodeToken(response);
    } catch (error) {
      throw error;
    }
  }

  async studentsCompletedAssignmentsAndCharts(body) {
    try {
      return await firstValueFrom(this.httpService.post<any>(`${environment.NODE_SERVER}/academic-progress`, body));
    } catch (error) {
      throw error;
    }
  }

  private async getDataForWeekPeriod() {
    try {
      const response: any = await this.getAssignmentEvaluationAndUsers({
        start_time: new Date('2023-05-29').setHours(0, 0, 0, 0),
        end_time: new Date('2023-06-03').setHours(0, 0, 0, 0),
        school_id: 1,
      });

      for (const assignment of response) {
        const createdAt = new Date(assignment.created_at);
        const dateKey = `${createdAt.getFullYear()}-${createdAt.getMonth() + 1}-${createdAt.getDate()}`;

        const dateIndex = this.dates.findIndex((date) => date === dateKey);

        if (dateIndex === -1) {
          this.dates.push(dateKey);
          this.totalAssignments.push(0);
          this.totalStudentsTakenAssignments.push(0);
          this.studentsCompletedAssignments.push(0);
        }

        const index = this.dates.findIndex((date) => date === dateKey);
        this.totalAssignments[index]++;
        this.totalStudentsTakenAssignments[index] += assignment.student_assignments.length;

        for (const studentAssignment of assignment.student_assignments) {
          if (studentAssignment.completed) {
            this.studentsCompletedAssignments[index]++;
          }
        }
      }

      return {
        chartLabel: this.getWeeks(),
        data: [this.totalAssignments, this.totalStudentsTakenAssignments, this.studentsCompletedAssignments],
      };
    } catch (error) {
      throw error;
    }
  }

  private getDataForMonthPeriod() {
    const nPoint = this.getMonths().length;

    return {
      chartLabel: this.getMonths(),
      data: [this.getRandomData(nPoint), this.getRandomData(nPoint), this.getRandomData(nPoint)],
    };
  }

  private getDataForYearPeriod() {
    const nPoint = this.year.length;

    return {
      chartLabel: this.year,
      data: [this.getRandomData(nPoint), this.getRandomData(nPoint), this.getRandomData(nPoint)],
    };
  }

  private getRandomData(nPoints: number): number[] {
    return Array.from(Array(nPoints)).map(() => {
      return Math.round(Math.random() * 100);
    });
  }

  getProfitChartData(period: any) {
    return this.data[period];
  }

  getYears() {
    return ['2010', '2011', '2012', '2013', '2014', '2015', '2016', '2017', '2018'];
  }

  getMonths() {
    return ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  }

  getWeeks() {
    return ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
  }

  async getAssignmentReport(school_id, start_time, end_time) {
    try {
      const params = new HttpParams()
        .set('school_id', school_id.toString())
        .set('start_time', start_time.toString())
        .set('end_time', end_time.toString());
      return firstValueFrom(
        this.httpService.get<any>(
          `${environment.XANO_SERVER_URL}${EndPoint.students_and_assignments_academic_progress}`,
          { params },
        ),
      );
    } catch (error) {
      throw error;
    }
  }
}
